export const profile = {
  name: 'Omar Abdelrazek',
  github: 'https://github.com/oabdelrazek29',
  linkedin: 'https://www.linkedin.com/in/omar-abdelrazek-7543852b0/',
  resume: '/resume/Omar-Abdelrazek-Resume.pdf',
  summary: 'Computer Science and Information Security student at John Jay College, building secure agent execution tools, backend services, and responsive web applications. Seeking software engineering, security engineering, and systems engineering internships.',
}
export const skills = ["C++", "Python", "JavaScript", "TypeScript", "SQL", "C", "Tailwind CSS", "React", "Node.js", "FastAPI", "PostgreSQL", "REST APIs", "Supabase", "Git", "GitHub", "Linux", "Vercel", "pytest", "GitHub Actions", "Unit testing", "CI workflows", "Authorization", "Access control", "Tenant isolation", "Parameterized SQL", "Permission boundaries"]

export const workExperience = [
  {
    "id": 1,
    "company": "Independent Client Work",
    "position": "Freelance Web Developer",
    "duration": "2026 \u2013 Present",
    "achievements": [
      "Design and develop responsive websites for local service businesses, translating requirements into polished interfaces, navigation, service descriptions, and mobile layouts.",
      "Implement interactive JavaScript components, Tailwind CSS styling, animations, and iterative design changes; deploy with Vercel and respond to client feedback.",
      "Manage demonstrations, technical revisions, pricing discussions, and maintenance planning, including a deployed automotive detailing website and additional client concepts."
    ]
  },
  {
    "id": 2,
    "company": "Ape AI",
    "position": "Founder\u2019s Assistant Intern",
    "duration": "July 2026 \u2013 Present",
    "achievements": [
      "Support the founder through product research, review of AI-generated outputs, assessment of development workflows, and prioritization of startup activities.",
      "Contribute to positioning and launch communications through research, founder-led video content, and product messaging for prospective users."
    ]
  },
  {
    "id": 3,
    "company": "Handshake AI",
    "position": "AI Response Evaluation Contractor",
    "duration": "June 2026",
    "achievements": [
      "Evaluated model responses for accuracy, clarity, instruction adherence, and reliability, documenting feedback to support quality improvements."
    ]
  }
]

export const projects = [
  {
    "id": "kestrel",
    "title": "Kestrel",
    "description": "Founder and developer of a private autonomy control and security startup focused on constraining autonomous AI agents to authorized assignments, even when agents hold broad tool permissions.",
    "technologies": [
      "Python",
      "FastAPI",
      "PostgreSQL",
      "pytest",
      "GitHub Actions"
    ],
    "category": "Agent Security",
    "status": "In Development",
    "year": "2026 \u2013 Present",
    "isPrivate": true,
    "features": [
      "Architecting an agent execution control layer that evaluates proposed tool actions against a trusted assignment and execution context.",
      "Implemented trusted principal and tenant checks before protected operations, reauthorization for each database request, and fixed parameterized SQL for tenant-scoped reads in bounded, read-only transactions.",
      "Tested cross-tenant access rejection before protected queries, lock timeout rollback, recovery, and authorized reads, with 76 passing automated tests at a verified checkpoint."
    ],
    "direction": "Defining enforcement boundaries between autonomous decision making and privileged execution while documenting failure cases, integration assumptions, and limits of the current prototype."
  }
]
